import { instanceToPlain } from 'class-transformer';
import { collection, doc, getDocs, setDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { Locker } from '../../entities/locker.entity';
import { Collections, db, functions } from '../../utils/firebase.config';
import { converterOf } from '../../utils/firebase.utils';
import UpdateLockerResource from './resources/update-locker.resource';

export const useLockers = () => {
  const lockersRef = collection(db, Collections.Lockers).withConverter(converterOf(Locker));

  const fetchAll = async (): Promise<Locker[]> => {
    const response = await getDocs(lockersRef);

    return response.docs.map((snapshot) => snapshot.data());
  };

  const create = async (input: Omit<Locker, 'id'>): Promise<Locker> => {
    const lockerDoc = doc(lockersRef);

    const data = new Locker({ ...input, id: lockerDoc.id });

    await setDoc(lockerDoc, data);

    return data;
  };

  const update = async (input: Partial<Locker> & { id: string }): Promise<Locker> => {
    const lockerDoc = doc(lockersRef, input.id);
    const data = new Locker(input);
    await setDoc(lockerDoc, data, { merge: true });

    return data;
  };

  const sync = async (input: Locker): Promise<void> => {
    const callable = httpsCallable<Record<string, unknown>, void>(functions, 'syncLocker');

    const locker = new UpdateLockerResource({
      id: input.id,
      lockerId: input.lockerId,
      condominium: input.condominiumId,
      vendor: input.vendor,
    });

    const data = instanceToPlain(locker);
    await callable(data);
  };

  return { fetchAll, create, update, sync };
};

export default useLockers;
